import {AssetStarExchangeOptionPutDataTransferObjectDescription} from "../../../data/data-transfer-object-description/asset/AssetStarExchangeOptionPutDataTransferObjectDescription"
import {AssetStarExchangeOptionPutState} from "../../../data/data-transfer-object-state/asset/AssetStarExchangeOptionPutState"
import {AssetStarExchangeOptionPutDataTransferObject} from "../../../data/data-transfer-object/asset/AssetStarExchangeOptionPutDataTransferObject"
import {PostBigIntField, PostBitMaskField, PostBooleanField, PostDateField, PostEnumField, PostFieldWrapper, PostInputField, PostNumberField, PostTextareaField} from "../../PostField"
import {RouterProps} from "../../RouterProps"
import {JSX} from "react"

type PostFieldProps = RouterProps & {
    state: AssetStarExchangeOptionPutState
}

export const AssetStarExchangeOptionPutField: Record<Capitalize<keyof AssetStarExchangeOptionPutDataTransferObject>, (props: PostFieldProps) => JSX.Element> = {
    StarAmount(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetStarExchangeOptionPutDataTransferObjectDescription.starAmount}>
                <PostNumberField
                    {...props}
                    value={props.state.starAmount.value}
                    setter={props.state.starAmount.setter} />
            </PostFieldWrapper>
        )
    },
    SolarAmount(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetStarExchangeOptionPutDataTransferObjectDescription.solarAmount}>
                <PostNumberField
                    {...props}
                    value={props.state.solarAmount.value}
                    setter={props.state.solarAmount.setter} />
            </PostFieldWrapper>
        )
    },
}

export function AssetStarExchangeOptionPutFields(props: PostFieldProps) {
    return <>
        <AssetStarExchangeOptionPutField.StarAmount
            {...props}
            state={props.state} />
        <AssetStarExchangeOptionPutField.SolarAmount
            {...props}
            state={props.state} />
    </>
}
